import Component from '../core/Component'
import enquire from 'enquire.js'
import { queries } from '../core/config'

import { toggleClass } from '../utils/dom'
import scrollTo from '../services/Viewport/scrollTo';

const ACTIVE = 'is-active'

export default class FormToggle extends Component {

    constructor(element) {
        super(element)

        this.enquireHandler = {
            match: ::this.match,
            unmatch: ::this.unmatch
        }
        this.isMobile = false
    }

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
        enquire.register(queries.largeMax, this.enquireHandler)
    }

    destroy() {
        enquire.unregister(queries.largeMax, this.enquireHandler)
    }

    match() {
        this.isMobile = true
    }

    unmatch() {
        this.isMobile = false
    }
    
    handleClick(event) {
        event.preventDefault()
        const showForm = this.element.getAttribute('data-form');
        const hideForm = this.element.getAttribute('data-hideForm');
        const showFormEl = document.getElementById(showForm);
        if(hideForm) {
            const hideFormEl = document.getElementById(hideForm);
            hideFormEl.classList.remove(ACTIVE)
        }
        showFormEl.classList.toggle(ACTIVE)
        if (this.isMobile) {
            const headerHeight = document.getElementById("header").offsetHeight;
            const bodyRect = document.body.getBoundingClientRect(),
                formRect = showFormEl.getBoundingClientRect(),
                offset   = formRect.top - bodyRect.top - headerHeight - 40;
            scrollTo(offset)
        }
    }
}
